<h1 mat-dialog-title>
  {{ 'Netdata' | translate }}

  <button
    class="dialog-close"
    mat-icon-button
    mat-dialog-close="close"
    ixTest="close"
  >
    <ix-icon name="close"></ix-icon>
  </button>
</h1>

<div mat-dialog-content>
  <p>
    {{ "We've generated a Netdata password and attempted to automatically log you in in a new tab." | translate }}
  </p>

  <p>{{ 'If automatic login has failed, please try the following credentials manually.' | translate }}</p>

  <div class="credentials">
    <div class="url">
      <div class="label">URL:</div>
      <div class="value">
        <a href="/netdata" target="_blank" ixTest="netdata-url">/netdata/</a>
      </div>
    </div>

    <ix-input
      class="username-input"
      [label]="'Username' | translate"
      [readonly]="true"
      [formControl]="usernameControl"
    ></ix-input>

    <ix-input
      class="password-input"
      [label]="'Password' | translate"
      [readonly]="true"
      [formControl]="passwordControl"
    ></ix-input>
  </div>

  <ix-form-actions>
    <button mat-button ixTest="generate" (click)="onGeneratePasswordPressed()">
      {{ 'Generate New Password' | translate }}
    </button>
    <button mat-button ixTest="cancel" [matDialogClose]="false">{{ 'Close' | translate }}</button>
  </ix-form-actions>
</div>
